import axios from 'axios'

const createRequest = (baseUrl) => {
    console.log(baseUrl, "baseUrl")
    var r = axios.create({
        // API 请求的默认前缀
        baseURL: baseUrl,
        timeout: 35000 // 请求超时时间
    });
    return r;
}

export {
    installer as VueAxios,
    request as axios,
    createRequest
}


// WEBPACK FOOTER //
// ./src/S51WebGLSDK/utils/request.js